import './login.css';
import { useEffect, useState } from 'react';
import logo from '../assets/images/dashboard/lepton-logo.png';
import { Button, CircularProgress } from '@mui/material';
import { fetchUserAuth } from '../utils/requests';
import loaderAnimated from '../assets/images/dashboard/loader_animated.gif';

const Login = ({ onLoginSuccess, showAlert, isLoading, setIsLoading }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [emailInvalid, setEmailInvalid] = useState(false);
    const [passwordEmpty, setPasswordEmpty] = useState(false);
    const [emailTouched, setEmailTouched] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    // const [isLoading, setIsLoading] = useState(false);
    const [authError, setAuthError] = useState(false); // Estado para error de autenticación

    const setCookie = (name, value, hours) => {
        let expires = "";
        if (hours) {
            const date = new Date();
            date.setTime(date.getTime() + (hours * 60 * 60 * 1000)); // horas → milisegundos
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/; secure=true;";
    };

    const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isFormValid = email !== '' && password !== '' && isEmailValid(email);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setAuthError(false);
        setErrorMessage('');
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setAuthError(false);
        setErrorMessage('');
    };

    const handleEmailBlur = () => {
        setEmailTouched(true);
        setEmailInvalid(!isEmailValid(email));
    };

    const handlePasswordBlur = () => {
        setPasswordEmpty(password === '');
    };

    const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!isFormValid) return;

        setIsLoading(true);
        setErrorMessage('');

        try {
            const response = await fetchUserAuth(email, password);
            if (response && response.hash) {
                setCookie('session_key', response.hash, 1);
                // Login exitoso, mostrar alerta
                showAlert("Inicio de sesión exitoso", "success");
                onLoginSuccess(response.hash); // Llamar la función onLoginSuccess pasada como prop
            }
        } catch (error) {
            setAuthError(true);
            setPassword('');
            setErrorMessage('Nombre de usuario y/o contraseña incorrectos.');
            setIsLoading(false);
            // Login fallido, mostrar alerta
            showAlert("Error al iniciar sesión. Por favor, revisa tus credenciales.", "error");
        } finally {
            // setIsLoading(false);
        }
    };

    // const getQueryParam = (param) => {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     return urlParams.get(param);
    // };

    // const getCookie = (name) => {
    //     const value = `; ${document.cookie}`;
    //     const parts = value.split(`; ${name}=`);
    //     if (parts.length === 2) return parts.pop().split(';').shift();
    //     return null;
    //   };

    // useEffect(() => {
    //     let hash = getQueryParam('session_key');
    //     console.log(hash)
    //     if (!hash) {
    //         hash = getCookie('session_key');
    //     }
    //     if (hash) {
    //         onLoginSuccess(hash);
    //     }
    //     setIsLoading(false);
    // }, []);

    return (
        <div className="login_container">
            {isLoading && (
                <div className="loading_overlay">
                    <img src={loaderAnimated} alt='Cargando' style={{ height: '6rem' }}></img>
                </div>
            )}
            <div className={`login_panel ${isLoading ? 'loading_blur' : ''}`}>
                <img src={logo} className="login_logo" alt="Logo" />
                <form className="login_form" onSubmit={handleLogin}>
                    <h2>Iniciar Sesión</h2>

                    <label className={`form_label ${(emailInvalid && emailTouched) || authError ? 'error' : ''}`} style={{ color: '#363949' }}>Correo electrónico</label>
                    <div className={`input_container ${(emailInvalid && emailTouched) || authError ? 'error' : ''}`}>
                        <span className={`material-symbols-rounded input_icon ${(emailInvalid && emailTouched) || authError ? 'error' : ''}`}>person</span>
                        <input
                            type="email"
                            placeholder="Introduce tu correo"
                            value={email}
                            onChange={handleEmailChange}
                            onBlur={handleEmailBlur}
                            required
                        />
                    </div>
                    {emailInvalid && emailTouched && (
                        <small className="error_message">Correo electrónico debe ser válido</small>
                    )}

                    <label className={`form_label ${passwordEmpty || authError ? 'error' : ''}`} style={{ color: '#363949' }}>Contraseña</label>
                    <div className={`input_container ${passwordEmpty || authError ? 'error' : ''}`}>
                        <span className={`material-symbols-rounded input_icon ${passwordEmpty || authError ? 'error' : ''}`}>lock</span>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Introduce tu contraseña"
                            value={password}
                            onChange={handlePasswordChange}
                            onBlur={handlePasswordBlur}
                            required
                        />
                        <button
                            type="button"
                            className="toggle_password"
                            onClick={togglePasswordVisibility}
                        >
                            <span className='material-symbols-rounded'>{showPassword ? 'visibility' : 'visibility_off'}</span>
                        </button>
                    </div>
                    {passwordEmpty && (
                        <small className="error_message">Campo obligatorio</small>
                    )}

                    {errorMessage && <small className="error_message">{errorMessage}</small>}

                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={!isFormValid || isLoading}
                        style={{ marginTop: 20, textTransform: 'none', fontSize: '1rem', fontWeight: '500', fontFamily: 'Poppins' }}
                    >
                        {isLoading ? <CircularProgress size={24} /> : "Iniciar sesión"}
                    </Button>
                    {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                        <a href='./' style={{ color: '#363949' }} >Olvidé mi contraseña</a>
                        <a href='./' style={{ color: '#363949' }} >Registrarse</a>
                    </div> */}
                </form>
            </div>
        </div>
    );
};

export default Login;
